module.exports = __webpack_public_path__ + "static/media/UN0309454.9723b750.jpg";